export default (requests) => {
    return {
        changePassword: (data) => {
            return requests.post('/customer/account/change-password', data);
        },
        forgotPassword: (email) => {
            return requests.post('/customer/account/reset-password', email);
        },
        logInUser: (user) => {
            return requests.post('/customer/session/login', user);
        },
        logoutUser: (sessionCookie) => {
            const config = {};
            sessionCookie ? config['headers'] = {'X-ODDS-SESSION': sessionCookie} : '';
            return requests.delete('/customer/session/logout', config);
        },
        isValueUnique: (fieldName, fieldValue) => {
            if (process.env.USE_VALIDATORS_UNIQUE){
                return requests.get(`/customer/validators/unique/${fieldName}/${fieldValue}`);
            } else {
                return requests.get(`/customer/account/is-value-unique/${fieldName}/${fieldValue}`);
            }
        },
        preregisterUser: (data) => {
            return requests.post('/customer/account/preregister', data);
        },
        registerUser: (user) => {
            return requests.post('/customer/account/register', user);
        },
        verificationCode: (data, turnstileToken)=>{
            const config = {};
            if (turnstileToken) {
                config['headers'] = {'turnstile-token': turnstileToken};
            }
            return requests.post('/customer/account/verification-code', data, config);
        },
        validateSMSCode: (fieldValue, mobileNumber, withAttempts = false) => {
            return requests.get(`/customer/customerInput/validation/preregistrationVerificationCode/${fieldValue}?additionalValue=${mobileNumber}${(withAttempts ? '&withAttempts=true' : '')}`);
        },
        fetchNewCustomerDataByMyId: (id) => {
            return requests.get(`/customer/identity-resolver/my-id/data/${id}`);
        },
        registerUserByMyId: (data) => {
            return requests.post('/customer/identity-resolver/my-id/register', data);
        },
        getBrandData: () => {
            return requests.get(`/configuration/brands`);
        },
        requestToSendSmsCodeToProlongSession: () => {
            return requests.post(`/customer/account/session/send-code`);
        },
        verifySmsCodeToProlongSession: (data) => {
            return requests.post(`/customer/account/session/verify-code`, data);
        }
    }
};